var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./overlay.css";
import { JSLRender } from "jsl-render";
var OverlayComponent = /** @class */ (function () {
    function OverlayComponent(options) {
        var _this = this;
        this.closeIcon = {
            tag: "div", content: "✖" /*"🗙"*/, attr: {
                class: "overl-close-btn", click: function () {
                    _this.close();
                }
            }
        };
        this.options = __assign({ closeOnEscape: true, closeOnOverlayClick: true, showCloseButton: true, direction: "left", animate: true }, options);
        if (this.options.closeOnEscape) {
            this.onKeydownEvent = document.addEventListener("keydown", function (args) {
                if (args.keyCode === 27) { // escape
                    _this.close();
                }
            });
        }
    }
    OverlayComponent.show = function (options) {
        var container = document.createElement("div");
        document.body.appendChild(container);
        var oldRenderer = JSLRender.lastCreatedRenderer;
        var oldLastDlg = OverlayComponent.lastRenderedDlg;
        var renderer = new JSLRender(container, oldRenderer != null);
        if (oldRenderer != null) {
            JSLRender.lastCreatedRenderer = renderer;
        }
        var o = __assign({}, options);
        o.onClose = function () {
            if (options.onClose) {
                if (options.onClose() === false) {
                    return;
                }
            }
            document.body.removeChild(container);
            JSLRender.lastCreatedRenderer = oldRenderer;
            if (oldRenderer != null) {
                oldRenderer.refresh();
            }
            OverlayComponent.lastRenderedDlg = oldLastDlg;
        };
        var dlg = new OverlayComponent(o);
        OverlayComponent.lastRenderedDlg = dlg;
        renderer.render(dlg);
        return dlg;
    };
    OverlayComponent.prototype.close = function () {
        if (this.options.onClose) {
            if (this.options.onClose() === false) {
                return;
            }
        }
        // this.overlay.style.display = "none";
        if (this.onKeydownEvent != null) {
            document.removeEventListener("keydown", this.onKeydownEvent);
        }
    };
    OverlayComponent.prototype.onCreate = function (node) {
        var bodyDom = node.dom.querySelector(".overl-body");
        if (bodyDom != null) {
            if (this.options.direction === "left") {
                node.dom.style.width = this.options.size;
                if (this.options.animate) {
                    var realWidth = bodyDom.getBoundingClientRect().width;
                    node.dom.style.left = -realWidth + "px";
                    JSLRender.animate(node, { attr: "left", from: -realWidth + "px", to: "0px", duration: 500, easing: "easeOutSine" });
                }
            }
            else {
                node.dom.style.height = this.options.size;
                if (this.options.animate) {
                    var realHeight = bodyDom.getBoundingClientRect().height;
                    node.dom.style.top = -realHeight + "px";
                    JSLRender.animate(node, { attr: "top", from: -realHeight + "px", to: "0px", duration: 500, easing: "easeOutSine" });
                }
            }
        }
        else {
            console.error("overl-body class not found");
        }
    };
    OverlayComponent.prototype.render = function () {
        var _this = this;
        var body = this.toNode(this.options.content);
        // let styleW = "";
        // let styleH = "";
        // if (this.options.width != null) {
        //     styleW += "width:" + this.options.width + ";";
        // }
        // if (this.options.minWidth != null) {
        //     styleW += "min-width:" + this.options.minWidth + ";";
        // }
        // if (this.options.maxWidth != null) {
        //     styleW += "max-width:" + this.options.maxWidth + ";";
        // }
        // if (this.options.height != null) {
        //     styleH += "height:" + this.options.height + ";";
        // }
        // if (this.options.minHeight != null) {
        //     styleH += "min-height:" + this.options.minHeight + ";";
        // }
        // if (this.options.maxHeight != null) {
        //     styleH += "max-height:" + this.options.maxHeight + ";";
        // }
        // const headerStyle = this.options.allowMove ? "cursor:move" : undefined;
        return {
            tag: "div", attr: {
                class: "jsl-overlay-overlay", click: function (e) {
                    if (_this.options.closeOnOverlayClick && e.target.classList.contains("jsl-overlay-overlay")) {
                        _this.close();
                    }
                }, wheel: function (e) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
            }, children: [
                {
                    tag: "div", attr: { class: ("overl-body-" + this.options.direction) + " overl-body " + (this.options.class || ""), style: this.options.style }, children: [{
                            tag: "div", attr: { class: "overl-header" },
                            children: this.options.showCloseButton ? [this.closeIcon] : []
                        }, body]
                }
            ]
            // }]
        };
    };
    OverlayComponent.prototype.toNode = function (content) {
        if (typeof content === "string") {
            return { tag: "div", content: content };
        }
        return content;
    };
    return OverlayComponent;
}());
export { OverlayComponent };
